module.exports = __webpack_public_path__ + "media/images/lb/177-ee1342be07e88cb4727ee2837e3b9dd2.svg";